// baseurl.js

// Backend API base URL
export const baseurl = "https://backend.measro.com/api/"; 
// export const baseurl = "http://localhost:5000/api/"; 

// Image base URL (for static uploads)
export const imgurl = "https://backend.measro.com"; 
// export const imgurl = "http://localhost:5000"; 
